/*
 * action types
 */
export const USER_FLAGS = 'USER_FLAGS'

/*
 * action creators
 */
export default function setUserFlags(payload) {
  return {
    payload,
    type: USER_FLAGS,
  }
}
